var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Success_Tick_Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 127
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Success_Tick_Icon",
    "data-name": "Success Tick Icon",
    clipPath: "url(#clip-Success_Tick_Icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3000",
    "data-name": "Group 3000",
    transform: "translate(-897 -248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1838",
    "data-name": "Group 1838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check_circle-24px",
    transform: "translate(897 248)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    width: 127,
    height: 127,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M0,0H127V127H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M63.5,10.583A52.917,52.917,0,1,0,116.417,63.5,52.936,52.936,0,0,0,63.5,10.583ZM52.917,89.958,26.458,63.5l7.461-7.461,19,18.944L93.08,34.819l7.461,7.514Z",
    fill: "#34cb81"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/SuccessTick.0bbe0ef67389e5daf51c787291f4c87f.svg";
export { ForwardRef as ReactComponent };